import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "onboarding-pact" }
const _hoisted_2 = { class: "onboarding-pact__cards" }
const _hoisted_3 = {
  key: 0,
  class: "onboarding-pact__title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "onboarding-pact__footer"
}
const _hoisted_7 = { class: "onboarding-pact__future-date" }
const _hoisted_8 = {
  key: 3,
  class: "onboarding-pact__button-wrapper"
}

import { computed, ref } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { CommitmentPactPage } from '@/models/onboarding.types'

import AppButton from '@/app/components/button/AppButton.vue'
import CommitmentFingerprint from '../CommitmentFingerprint.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommitmentPact',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as CommitmentPactPage
})

const isCardFlipped = ref(false)

function getCardText(isFrontFace: boolean): string {
  const initialText = isFrontFace
    ? page.value.textInitial
    : page.value.textFinal

  const parsedText = initialText
    .split('<br>')
    .map((block) => `<p>${block}</p>`)
    .join('')

  if (isFrontFace) {
    return parsedText
  } else {
    return parsedText
      .replace(/{{futureYear}}/g, futureYear)
      .replace(/{{currentDate}}/g, currentDateText)
  }
}

const currentDate = new Date()
const futureDate = new Date(currentDate)
futureDate.setFullYear(currentDate.getFullYear() + 1)

const currentDateText = currentDate.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})
const futureDateText = futureDate.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})
const futureYear = futureDate.getFullYear().toString()

function flipCard(): void {
  isCardFlipped.value = true
  setTimeout(() => {
    props.view.showContinueButton()
  }, 2000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "flip",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: `${isCardFlipped.value}`,
          class: "onboarding-pact__cards-wrapper"
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            class: "onboarding-pact__sparkle",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 43 55"
          }, [
            _createElementVNode("path", {
              d: "M42.845 19.801a36.335 36.335 0 0 1-6.607-6.632A36.846 36.846 0 0 1 29.89.3a.415.415 0 0 0-.395-.3.415.415 0 0 0-.396.3 37.327 37.327 0 0 1-6.472 13.004 37.04 37.04 0 0 1-6.472 6.497.43.43 0 0 0-.155.33c0 .126.068.252.164.33a34.669 34.669 0 0 1 6.473 6.235c3.033 3.81 5.216 8.184 6.472 12.994.048.184.212.31.396.31a.413.413 0 0 0 .396-.32c1.072-4.761 3.217-9.25 6.202-12.975a31.174 31.174 0 0 1 6.723-6.225.405.405 0 0 0 .174-.33.45.45 0 0 0-.155-.34v-.009ZM14.914 43.89a20.084 20.084 0 0 1-3.67-3.647 20.184 20.184 0 0 1-3.527-7.078.23.23 0 0 0-.22-.165.23.23 0 0 0-.22.165 20.449 20.449 0 0 1-3.595 7.152 20.478 20.478 0 0 1-3.596 3.574.235.235 0 0 0-.086.181c0 .07.038.139.091.181a19.177 19.177 0 0 1 3.596 3.43 19.108 19.108 0 0 1 3.596 7.146.227.227 0 0 0 .22.171.229.229 0 0 0 .22-.176 17.595 17.595 0 0 1 3.445-7.136 17.25 17.25 0 0 1 3.735-3.424.222.222 0 0 0 .097-.181.246.246 0 0 0-.086-.187v-.005Z",
              fill: "#FFC906"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: _normalizeClass(["onboarding-pact__card", {
              'onboarding-pact__card--front': n === 1,
              'onboarding-pact__card--back': n === 2,
              'onboarding-pact__card--visible':
                (n === 1 && !isCardFlipped.value) || (n === 2 && isCardFlipped.value),
            }])
              }, [
                (n === 2)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Note to Self"))
                  : (_openBlock(), _createElementBlock("h1", {
                      key: 1,
                      class: "onboarding-pact__title",
                      innerHTML: page.value.title
                    }, null, 8, _hoisted_4)),
                _createElementVNode("div", {
                  class: "onboarding-pact__text",
                  innerHTML: getCardText(n === 1)
                }, null, 8, _hoisted_5),
                (n === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "onboarding-pact__text-footer" }, [
                        _createTextVNode(" Thanks,"),
                        _createElementVNode("br"),
                        _createTextVNode("You from the future ")
                      ], -1)),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(futureDateText)), 1),
                      _createVNode(CommitmentFingerprint, { class: "onboarding-pact__fingerprint" })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(AppButton, {
                        class: "onboarding-pact__button",
                        disabled: isCardFlipped.value,
                        onClick: flipCard
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Commit ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
              ], 2)
            }), 64))
          ])
        ]))
      ]),
      _: 1
    })
  ]))
}
}

})